# TODO: brittany 10/5 - Stale? #direct_message selector does not exist in social tab; views associated with this
# selector are no longer in the codebase (see https://github.com/CareerPlug/ats/commit/7abebc220e1986cc5ee2b7ba8ed86ee2975bdd90)

$(
  $(document).on 'change', '#direct_message .checkbox input', ->
    the_list = $(this).closest('.list')
    limit = parseInt(the_list.attr('data-limit'))
    len = the_list.find('input:checked').length
    return false if limit > 0 && len > limit
    if len > 0
      $('#direct_message .list-container p.note span').text(' - ' + len + ' selected')
    else
      $('#direct_message .list-container p.note span').text('')
    return true
)
